import React from "react"
import "./grid.css"

function Grid({ children }) {
  return <article className="grid">{children}</article>
}

export default Grid
